const language = process.env.GATSBY_SITE_LANGUAGE || 'en'

var siteSettings = {
  en: {
    siteTitle: "SwipeStation - HALF TIME DRINKS. IN HALF THE TIME.",
    description: "SwipeStation is a contact-free mobile payment service that has proven to eliminate queues in large venues.",
    siteUrl: 'https://swipestation.co.uk'
  },
  sa: {
    siteTitle: "SwipeStation - HALFTYD DRANK. IN DIE HALFTE TYD.",
    description: "SwipeStation is 'n kontakvrye mobiele betaaldiens wat bewys het dat dit toue in groot lokale uitskakel.",
    siteUrl: 'https://swipestation.co.sa'
  }
};

var siteLanguage = siteSettings[language]

var config = {
  site: {
    siteTitle: siteLanguage.siteTitle,
    language: language,
    siteSettings: siteSettings,
    shortName: "SwipeStation",
    siteUrl: siteLanguage.siteUrl,
    bgColor: "#ffffff",
    themeColor: "#FFBA00",
    favIcon: "src/assets/favicon.png",
    description: siteLanguage.description,
  },
  project: {
    projectId: "fxgsdm3u",
    dataset: "production",
  },
};

module.exports = config;
